export default "__VITE_ASSET__5de58976__"